export const MT_PURCHASE_ORDER_VI = {
  title: 'Đơn đặt hàng kênh hiện đại',
  pageName: 'Đơn đặt hàng kênh hiện đại',
  titleDetail: 'Chi tiết đơn đặt hàng kênh hiện đại',
  all: 'Tất cả',
  created: 'Mới',
  canceled: 'Đã hủy',
  waiting_finance: 'Chờ kế toán',
  waiting_inbound: 'Chờ nhập hàng',
  inbounded: 'Đã nhập hàng',
  full_paid: 'Hoàn tất thanh toán',
  mtNumber: 'Mã đơn',
  createMT: 'Tạo đơn đặt hàng kênh hiện đại',
  barCode: 'Mã vạch',
  packingSpec: 'Thông số đóng gói',
  retailPrice: 'Giá bán lẻ(Chưa bao gồm VAT)',
  poPrice: 'Giá đơn đặt hàng(Chưa bao gồm VAT)',
  orderQuantity: 'Số lượng đặt hàng theo đơn vị tính',
  promotionPrice: 'Giá trị khuyến mãi(Chưa bao gồm VAT)',
  poPriceVAT: 'Giá đơn đặt hàng(VAT)',
  grossWeight: 'Tổng trọng lượng (kg)',
  netValue: 'Giá trị cuối(Chưa bao gồm VAT)',
  netPOValue: 'Giá trị cuối đơn đặt hàng(Chưa bao gồm VAT)',
  netPOValueVAT: 'Giá trị cuối đơn đặt hàng(VAT)',
  netPOValue2: 'Giá trị cuối đơn đặt hàng',
  promotionDiscount: 'Chương trình khuyến mãi',
  warningCancel: 'Bạn có chắc chắn muốn hủy đơn đặt hàng này không?',
}
